/**
 * Project Portfolio constants
 */

/**
 * Project status values from backend/Typesense
 * These correspond to the StatusName field in the projects collection
 */
export const PROJECT_STATUSES = [
  'Quote',
  'Approved',
  'InProgress',
  'OnHold',
  'Completed',
  'Archived',
  'Cancelled',
] as const;

/**
 * Health status values from backend/Typesense
 * These correspond to the HealthStatusName field in the projects collection
 */
export const HEALTH_STATUSES = ['AtRisk', 'OnTrack'] as const;

export const PROJECT_ID_PARAMETER_NAME = 'project-id';
